var BASE_FILE_KEY = 'file';
var fileKeys = {
  allFiles: [BASE_FILE_KEY],
  fileStatus: function fileStatus(fileId) {
    return [BASE_FILE_KEY, 'status', fileId];
  }
};
export default fileKeys;